var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"my-0"},[_c('v-card-title',{staticClass:"display-1"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('v-card-text',[_c('highcharts',{attrs:{"options":_vm.chartOptions}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }